import React from 'react';
import './ModalWindow.css';


export function ModalWindow (props) {
 
  return (
    <div className={`modal-overlay  modal_type_${props.title} ${props.isAnimating ? 'closing' : ''}`} onClick={props.toggleModal}>
    <div className={`modal__container modal__container__type_${props.title}`} onClick={e => e.stopPropagation()}>   
      <button onClick={props.onClose} type="button" className="modal__close" aria-label="Закрыть форму"></button> 
      {props.children}
    </div>
  </div>
  
  )
}
